import { render } from "./PrivacyWidget.vue?vue&type=template&id=497ed290"
import script from "./PrivacyWidget.vue?vue&type=script&lang=js"
export * from "./PrivacyWidget.vue?vue&type=script&lang=js"

import exportComponent from "/home/mw/Code/hc-vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__